import React from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function FaqAdd() {
    const navigate = useNavigate();

    const [formValue, setformValue] = React.useState({
        pertanyaan: "",
        jawaban: "",
        tanggal: "",
    });

    const handleChange = (event) => {
        setformValue({
            ...formValue,
            [event.target.name]: event.target.value,
        });
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const requestData = {
            pertanyaan: formValue.pertanyaan,
            jawaban: formValue.jawaban,
            tanggal: formValue.tanggal, // pastikan tanggal ada di formValue
        };

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/faqs/createFaq`,
                requestData, // kirim data dalam format JSON
                {
                    headers: {
                        "Content-Type": "application/json",
                        authorization: token,
                    },
                }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil ditambah",
                icon: "success",
            });
            navigate("/faq");
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: "Error",
                text: "Data gagal ditambah",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                {/* Content Header (Page header) */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Faq</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Faq</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah Faq</h3>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Pertanyaan</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="pertanyaan"
                                                        placeholder="Masukkan Pertanyaan"
                                                        onChange={handleChange}
                                                        value={formValue.pertanyaan}
                                                        rows="4"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Jawaban</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="jawaban"
                                                        placeholder="Masukkan jawaban"
                                                        onChange={handleChange}
                                                        value={formValue.jawaban}
                                                        rows="4"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Tanggal</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="tanggal"
                                                        onChange={handleChange}
                                                        value={formValue.tanggal}
                                                    />
                                                </div>

                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/faq">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                            {/* /.card-body */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default FaqAdd;
